export function sanitizeFeePercentInput(text: string): string {
    let sanitized = '';
    let hasPoint = false;
    let decimalDigits = 0;

    for (const char of text) {
        const isDigit = char >= '0' && char <= '9';

        if (isDigit) {
            if (hasPoint) {
                if (decimalDigits >= 2) continue;
                decimalDigits += 1;
            }
            sanitized += char;
        } else if ((char === '.' || char === ',') && !hasPoint) {
            hasPoint = true;
            sanitized += '.';
        }
    }

    return sanitized;
}
